import { FluxStandardAction } from 'flux-standard-action'
import {
  GET_INQUIRY_LOGS,
  GET_INQUIRY_LOG_DETAILS,
  POST_INQUIRY_QUESTION,
  PUT_INQUIRY,
} from '../constants/inquiry.constant'
import { Inquiry } from '../interfaces/inquiry'
export const setInquiries = (
  result: Inquiry[]
): FluxStandardAction<any, any> => ({
  type: GET_INQUIRY_LOGS,
  payload: result,
  meta: null,
})
export const setInquiryDetails = (
  result: Inquiry
): FluxStandardAction<any, any> => ({
  type: GET_INQUIRY_LOG_DETAILS,
  payload: result,
  meta: null,
})

export const postInquiryQuestion = (
  data: any
): FluxStandardAction<any, any> => ({
  type: POST_INQUIRY_QUESTION,
  payload: data,
  meta: null,
})

export const putInquiry = (data: any): FluxStandardAction<any, any> => ({
  type: PUT_INQUIRY,
  payload: data,
  meta: null,
})



// WEBPACK FOOTER //
// ./src/actions/inquiry.action.ts